import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const OGBPayQRCode = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/OGBPay.png" style={style} />
}
